import API from '../api'
import putUrl from './paths'

export const updateLead = (lead) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateLead, { ...lead })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const updateLeadStatus = (leadId, taskType, notes) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateLeadStatus, { ...notes }, { leadId, taskType })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const addLeadTask = (leadId, task) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addLeadTask, { ...task }, { leadId })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const updateTaskReminder = (leadId, reminderId, body) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateTaskReminder, { ...body }, { leadId, reminderId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const updateStatus = (leadId, leadStatus) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateStatus, {}, { leadId, leadStatus })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})


export const assignLeadManager = (leadId, managerUserId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.assignLeadManager, {}, { leadId, managerUserId })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const addMeetingRemarks = (leadId, meetingId, remarks) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addMeetingRemarks, { remarks }, { leadId, meetingId })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})
